import script from "./InlinePreloader.vue?vue&type=script&setup=true&lang=js"
export * from "./InlinePreloader.vue?vue&type=script&setup=true&lang=js"

import "./InlinePreloader.vue?vue&type=style&index=0&id=bd4ef4ca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd4ef4ca"]])

export default __exports__